/*
 * This function returns a worker script which can be converted into a data URL.
 * To understand why this approach is needed, see the comment where this function
 * is called in wasm-mre-package/src/index.ts

 * WORKER_JS_STRING will be set at build time by copying in the contents of
 * SDLWasmLibWorker.js. This happens in buildwasmpackage.py.
 * The variable name emscriptenAssetFolderPath will be included within this string
 * in template literal form; we must keep the variable with the same name as a
 * function argument here: even though it appears unused when looking at this file
 * in isolation, it will be used once the python script has updated the file during
 * build.
 *
 * We adopt this approach as, although a bit funky, it seems preferable to hard-coding
 * the worker's JS as a string.
 *
 * TODO: test this file somehow AFTER it has been "built" by the python script.
 * Some Playwright tests which check behaviour that relies on the workers should catch
 * problems, but it would also be nice to be able to run a jest test suite against
 * the BUILD package code.
 */
export const makeWorkerScript = (emscriptenAssetFolderPath) => {
    return `




const ASSET_PATH_PREFIX = "${emscriptenAssetFolderPath}";

const messageBuffer = [];

self.onmessage = (msg) => {
  messageBuffer.push(msg);
};

const flushMessageBuffer = () => {
  for (const msg of messageBuffer) {
    self.onmessage(msg);
  }
  messageBuffer.length = 0;
};

async function initializeModule() {
  try {
    const { default: createModule } = await import(
      ASSET_PATH_PREFIX + "/SDLWasmLib.mjs"
    );
    Module = await createModule({
      locateFile: (path) => {
        return ASSET_PATH_PREFIX + "/" + path;
      },
    });
  } catch (error) {
    console.error("Failed to load WASM module: ", error);
    throw error;
  }

  try {
    flushMessageBuffer();
  } catch (error) {
    console.error("Failed to flush message buffer: ", error);
    throw error;
  }
}

initializeModule();

  `;
};
